import React, { useState } from "react";
import PropTypes from "prop-types";

function List({
  elements,
  component,
  didSelect,
  className,
  disabled,
  overrideIndex
}) {
  const [selectedIndex, setSelectedIndex] = useState(null);

  // If multiple elements contain "selected: true", only the last one rendered will be checked
  return (
    <div className={className}>
      {elements.map((el, i) => {
        return (
          <div
            key={el.id}
            id={i}
            onClick={e => {
              e.preventDefault();
              e.stopPropagation();
              if (disabled || el.disabled) return;
              setSelectedIndex(i);
              didSelect(el);
              return false;
            }}
            className="pb-2"
          >
              {component({ element: el, disabled: disabled || el.disabled })}
              <span
                disabled={disabled}
                readOnly
                checked={
                  // eslint-disable-next-line
                  selectedIndex !== null && !overrideIndex
                    ? i == selectedIndex
                    : el.selected
                }
              />
          </div>
        );
      })}
    </div>
  );
}

List.propTypes = {
  elements: PropTypes.array,
  component: PropTypes.func,
  didSelect: PropTypes.func,
  className: PropTypes.string,
  disabled: PropTypes.bool
};

List.defaultProps = {
  elements: [],
  component: () => {},
  didSelect: () => {},
  className: "",
  disabled: false
};

export default List;
